var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "renewing-membership membership-options confirm-electoral step-3-wrapper",
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 40 } },
        [
          _c("el-col", { staticClass: "receipt-box", attrs: { md: 12 } }, [
            _c("h6", { staticClass: "receipt-title" }, [
              _vm._v("Your Payment Confirmation"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "info-box" },
              [
                _vm._l(_vm.members, function (person) {
                  return _c(
                    "h6",
                    { key: person.id, staticClass: "receipt-info bold" },
                    [_vm._v(_vm._s(person.fullName))]
                  )
                }),
                _vm._v(" "),
                _c("h6", { staticClass: "receipt-info" }, [
                  _vm._v(_vm._s(_vm.fullAddress)),
                ]),
              ],
              2
            ),
            _vm._v(" "),
            _vm.receipt.last_4_card
              ? _c("div", { staticClass: "info-box" }, [
                  _c("h6", { staticClass: "receipt-info bold" }, [
                    _vm._v("Credit Card"),
                  ]),
                  _vm._v(" "),
                  _c("h6", { staticClass: "receipt-info" }, [
                    _vm._v("ending in " + _vm._s(_vm.receipt.last_4_card)),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "info-box" }, [
              _c("h6", { staticClass: "receipt-info bold" }, [
                _vm._v("Thank you, your payment has been processed."),
              ]),
              _vm._v(" "),
              _c("h6", { staticClass: "receipt-info" }, [
                _vm._v("Total Payment of $" + _vm._s(_vm.receipt.amount_paid)),
              ]),
              _vm._v(" "),
              _c("h6", { staticClass: "receipt-info" }, [
                _vm._v(
                  "Receipt Number: " + _vm._s(_vm.receipt.reference_number)
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { md: 12 } }, [
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.rightDescription) },
            }),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }